import { render } from "./TicketMultiple.vue?vue&type=template&id=7a0eb1b4"
import script from "./TicketMultiple.vue?vue&type=script&lang=js"
export * from "./TicketMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__